import React, { useEffect, useState }  from 'react';
import { apiMain } from '../../App';
import { GetDataPromise } from '../Functions/SendingData';
import { LoadingFull } from '../LoadingFull';
import Default from './Default';
import ImageTop9 from './ImageTop9';
import AboutusMain10 from './AboutusMain10';
import TextBox11 from './TextBox11';
import FullContact12 from './FullContact12';
import ToursCarousel6 from './ToursCarousel6';
import AgenciesCarousel4 from './AgenciesCarousel4';
import SliderWSearch3 from './SliderWSearch3';
import SliderNormal1 from './SliderNormal1';
import ErrorPage13 from './ErrorPage13';
import AgencyMain14 from './AgencyMain14';
import TourMain16 from './TourMain16';
import AgencyList15 from './AgencyList15';
import TourList17 from './TourList17';
import Banner4Main5 from './Banner4Main5';
import BannerOneMain18 from './BannerOneMain18';
import MetaTags19 from './MetaTags19';
import { makeViewEvent, resetReachData, setMetaTags, updateOrgData, updateOrgDataBussiness, updateWebsiteData } from '../Functions/SetHeaders';
import HeaderWithTitle20 from './HeaderWithTitle20';
import OnlySearchBar21 from './OnlySearchBar21';
import Stages22 from './Stages22';
import CtaInPage23 from './CtaInPage23';
import FaqSmall24 from './FaqSmall24';
import BannerWithTitle25 from './BannerWithTitle25';
import BreadCrumb28 from './BreadCrumb28';
import Continents26 from './Continents26';
import BoxImages29 from './BoxImages29';
import BoxImageText30 from './BoxImageText30';
import Countries27 from './Countries27';
import CtaTextInPage32 from './CtaTextInPage32';
import InstallApp33 from './InstallApp33';
import Pricing34 from './Pricing34';
import CountryFilterBroker35 from './CountryFilterBroker35';
import BrokerFilter36 from "./BrokerFilter36";
import BrokerMain37 from './BrokerMain37';
import HotelsMain38 from './HotelsMain38';

export default function PageBuilder (props){
  const { page , vars} = props;
  const [pageData, setPageData] = useState([]);
  const [pageDataMeta, setPageDataMeta] = useState([]);
  const [loading, setLoading] = useState(false);
  const [varsBase, setVarsBase] = useState({});
  useEffect(() => {
    getData();
  }, [])
  useEffect(() => {
    let check = false;
    if(!vars){
      return;
    }
    let keys = Object.keys(vars)
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if(varsBase[key] !== vars[key]){
        check = true;
      }
    }
    if(check) {
      setVarsBase(vars)
    }
  }, [vars])
  useEffect(() => {
    getData();
  }, [varsBase])
  const getData = async(force = false) => {
    resetReachData();
    if(page.search("home_web") !== -1){
      updateWebsiteData(props.lan.filename);
      updateOrgData(props.lan.filename);
    }
    if(page.search("travel_agency") !== -1 || page.search("luxintrip_operators") !== -1){
      updateOrgDataBussiness(props.lan.filename);
    }

    setLoading(true);
    let URLparams = new URLSearchParams();

    URLparams.append("Vi_Name", page)
    if(vars){
      let keys = Object.keys(vars);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        URLparams.append(key, vars[key])
      }
    }

    let res = await GetDataPromise(`${apiMain}/api/v1/setting/views/select?${URLparams.toString()}`, force);
    let parsed = JSON.parse(res);


    if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
      if(parsed.data.length){
        
        setPageData(parsed.data);
        setLoading(false);
        // if no ribbid 19 set default
        let dataList = parsed.data;
        if(dataList){
          let findIndex = dataList.findIndex((v) => parseInt(v.Ribb_Id) === 19);
          if (findIndex === -1) {
            setMetaTags("Luxintrip", "");
          }
          findIndex = dataList.findIndex((v) => parseInt(v.Ribb_Id) === 28);
          if(findIndex !== -1){
            setPageDataMeta(dataList[findIndex]);
          }
          if(dataList.length){
            makeViewEvent(dataList[0].Vi_Code, JSON.stringify(vars))
          }
        }
        return;
      }
    }

    setPageData([
      {
        "Vi_Ribb_Id": 36,
        "Ribb_Id": 8,
        "Vi_Ribb_Data": "{}",
        "Vi_Ribb_Priority": 0,
    },
    {
        "Vi_Ribb_Id": 37,
        "Ribb_Id": 13,
        "Vi_Ribb_Data": "{}",
        "Vi_Ribb_Priority": 1,
    }
  ])
   setLoading(false);
}
  const tryJSON = (stringData) => {
    try {
      return JSON.parse(stringData);
    } catch (e) {
      return stringData;
    }
  }
  const makeRibbon = (data = {}, index) => {
   // console.log( data) 
    switch(data.Ribb_Id){
      case 1: 
        return (
          <SliderNormal1 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 3: 
        return (
          <SliderWSearch3 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 4:
        return (
          <AgenciesCarousel4
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            list={data.Agency}
          />
        )
      case 5:
        return (
          <Banner4Main5 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 6:
        return (
          <ToursCarousel6
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            list={data.Tour}
          />
        )
      case 8:
        return (
          <div className="navpad" key={data.Vi_Ribb_Id}></div>
        )
      case 9:
        return (
          <ImageTop9 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 10:
        return (
          <AboutusMain10 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 11:
        return (
          <TextBox11 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} dataMain={pageDataMeta}/>
        )
      case 12:
        return (
          <FullContact12 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 13:
        return (
          <ErrorPage13 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 14:
        return (
          <AgencyMain14
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            agency={data.Agency}
          />
        );
      case 15:
        return (
          <AgencyList15
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
          />
        )
      case 16:
        let newDetails = (data.Tour.DETAIL) ? data.Tour.DETAIL : [];
        for (let i = 0; i < newDetails.length; i++) {
          const element = newDetails[i];
          element.DESC = tryJSON(element.Tour_Det_Desc)
        }
        return (
          <TourMain16
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            tour={{
              ...data.Tour,
              DETAIL: newDetails,
            }}
          />
        )
      case 17:
        return (
          <TourList17
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            dataMain={pageDataMeta}
          />
        )
      case 18:
        return (
          <BannerOneMain18 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 19:
        return (
          <MetaTags19 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} dataMain={pageDataMeta}/>
        )
      case 20:
        return (
          <HeaderWithTitle20 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} dataMain={pageDataMeta}/>
        )
      case 21:
        return (
          <OnlySearchBar21 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 22:
        return (
          <Stages22 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 23:
        return (
          <CtaInPage23 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 24:
        return (
          <FaqSmall24 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 25:
        return (
          <BannerWithTitle25 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 26:
        return (
          <Continents26 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} list={data.Continent}/>
        )
      case 27:
        return (
          <Countries27 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} list={data.Country}/>
        )
      case 28:
        return (
          <BreadCrumb28 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data} dataMain={pageDataMeta}/>
        )
      case 29:
        return (
          <BoxImages29 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 30:
        return (
          <BoxImageText30 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 32:
        return (
          <CtaTextInPage32 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 33:
        return (
          <InstallApp33 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 34:
        return (
          <Pricing34 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 35:
        return (
          <CountryFilterBroker35 {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      case 36:
        return (
          <BrokerFilter36
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            pageDataMeta={pageDataMeta}
          />
        );
      case 37:
        return (
          <BrokerMain37
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            agency={data.Agency}
          />
        );
      case 38:
        return (
          <HotelsMain38
            {...props}
            key={data.Vi_Ribb_Id}
            data={data.Vi_Ribb_Data}
            hotels={data.Hotels}
          />
        );
      case "default":
        return (
          <Default {...props} key={data.Vi_Ribb_Id} data={data.Vi_Ribb_Data}/>
        )
      default:
        return "";
    }
  }
  const makePage = (data = []) => {
    return data.map((v, i) => {
      return makeRibbon(v, i)
    })
  }
  if(loading){
    return (
        <LoadingFull/>
    )
  }
  return (
    <>
      {makePage(pageData)}
    </>
  )
}

